export default {
    name: "Add",
    data() {
        return {
            form: {
                name: null,
                isEnable: null,
                remark: null
            },
            rowSize: 6,
            systemFunctionIdLists: [],
            userAccountLists: [],
            checkedAuth: []
        }
    },
    mounted: function () {
    },
    watch: {
        '$i18n.locale' (val) {
            this.refreshAuthInfo(val);
        }
    },
    computed: {
        rules() {
            return {
                name: [
                    {required: true, message: this.$t('roleManage.message.name'), trigger: 'blur'},
                    {max: 50, message: this.$t('roleManage.message.tooLong') + 50, trigger: 'blur'}
                ],
                isEnable: [
                    {required: true, message: this.$t('roleManage.message.isEnable'), trigger: 'blur'}
                ],
                remark: [
                    {max: 500, message: this.$t('roleManage.message.tooLong') + 500, trigger: 'blur'}
                ]
            }
        },
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
        const systemCode = JSON.parse(sessionStorage.getItem('currentSystem')).code;
        this.$axios.get('/api/RolesManages/accountAndFunction', {params: {systemCode: systemCode}}).then(response => {
            this.systemFunctionIdLists = response.data.resultData[0];
            this.systemFunctionIdLists[0].disabled = true;
            this.checkedAuth.push(this.systemFunctionIdLists[0].code);
            // 原代码
            // this.userAccountLists = response.data.resultData[1];
            // 解决序号：21 问题
            this.userAccountLists = response.data.resultData[1].filter(row => row.userAccount !== 'admin');
            this.refreshAuthInfo(this.$i18n.locale);
        }).catch(e => {
            console.log(e);
        });

    },
    methods: {
        add() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // console.log(this.form);
                    // console.log(this.$refs.menuTree.getCheckedNodes());
                    // console.log(this.getAllPid(this.$refs.menuTree.getCheckedNodes()));
                    const userAccountLists = [];
                    this.userAccountLists.forEach(user => {
                        if (user.isChecked) {
                            userAccountLists.push({accountId: user.id});
                        }
                    });
                    const param = Object.assign({}, param, this.form);
                    param.userAccountLists = userAccountLists;
                    const authNodes = this.$refs.menuTree.getCheckedNodes(true);
                    const systemFunctionIdLists = [];
                    authNodes.forEach(item => {
                        systemFunctionIdLists.push({systemFunctionId: item.code});
                    });
                    systemFunctionIdLists.push(...this.getAllPid(authNodes));
                    param.systemFunctionIdLists = systemFunctionIdLists;
                    this.$axios.post('/api/RolesManages/insertRoles', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.back();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        getAllPid(nodes) {
            const codes = [];
            const added = [];
            nodes.forEach(item => {
                const code = this.getPid(item);
                if (added.indexOf(code) === -1 && code) {
                    codes.push({systemFunctionId: code});
                    added.push(code);
                }
            });
            return codes;
        },
        getPid(node) {
            let pCode = 0;
            this.systemFunctionIdLists.forEach(item => {
                if (item.children) {
                    item.children.forEach(row => {
                        if (row.code === node.code) {
                            pCode = item.code;
                        }
                    });
                }
            });
            return pCode;
        },
        refreshAuthInfo(locale) {
            this.systemFunctionIdLists.forEach(item => {
                if (item.children) {
                    item.children.forEach(row => {
                        this.itemLabel(row, locale);
                    });
                }
                this.itemLabel(item, locale);
            });
            this.systemFunctionIdLists = [...this.systemFunctionIdLists];
        },
        itemLabel(item, locale) {
            if(locale.indexOf('en') !== -1){
                item.label = item.tooltipText;
            }else{
                item.label = item.displayText;
            }
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        }
    }
}
